import classNames from 'classnames';
import { tp } from '@/shared/lib/typograf';
import Image from '../../shared/Image';
import Typografed from '../../shared/Typografed';

export type RhythmEvent = {
    time: string;
    title: string;
    description: string;
    image: {
        src: string;
        alt?: string;
        width: number;
        height: number;
    };
};

export type RhythmSectionProps = {
    title: string;
    description: string;
    events: RhythmEvent[];
};

type Props = React.HTMLAttributes<HTMLElement> & {
    rhythmSectionProps: RhythmSectionProps;
};

const RhythmSection = ({ rhythmSectionProps, ...props }: Props) => {
    return (
        <section
            {...props}
            className={classNames('rhythm-section js-header-theme-trigger', props.className)}
            data-theme="light"
        >
            <div className="rhythm-section__wrapper wrapper">
                <div className="rhythm-section__header">
                    {rhythmSectionProps.title && (
                        <h2
                            className="rhythm-section__title h2"
                            dangerouslySetInnerHTML={{ __html: tp(rhythmSectionProps.title) }}
                        ></h2>
                    )}
                    {rhythmSectionProps.description && (
                        <p
                            className="rhythm-section__description text-s text-opacity"
                            dangerouslySetInnerHTML={{ __html: tp(rhythmSectionProps.description) }}
                        ></p>
                    )}
                </div>
                <div className="rhythm-section__timeline">
                    <div className="rhythm-section__line" aria-hidden="true"></div>
                    {rhythmSectionProps.events.length > 0 && (
                        <ul className="rhythm-section__list">
                            {rhythmSectionProps.events.map((event) => (
                                <li key={`${event.time}-${event.title}`} className="rhythm-section__item">
                                    <div className="rhythm-section__item-dot" aria-hidden="true"></div>
                                    <div className="rhythm-section__item-content">
                                        <div className="rhythm-section__item-text">
                                            {event.title && (
                                                <h3 className="rhythm-section__item-title text-xl">
                                                    <Typografed>{event.title}</Typografed>
                                                </h3>
                                            )}
                                            {event.description && (
                                                <div
                                                    className="rhythm-section__item-description text-s wysiwyg"
                                                    dangerouslySetInnerHTML={{ __html: tp(event.description) }}
                                                ></div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="rhythm-section__item-side">
                                        {event.time && (
                                            <p className="rhythm-section__item-time text-xl text-opacity">
                                                <Typografed>{event.time}</Typografed>
                                            </p>
                                        )}
                                        <div className="rhythm-section__item-image">
                                            <Image
                                                src={event.image.src}
                                                alt={event.image.alt || event.title}
                                                width={event.image.width}
                                                height={event.image.height}
                                                sizes="151px"
                                            />
                                        </div>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            </div>
        </section>
    );
};

export default RhythmSection;
